var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-fixed"},[_c('van-swipe',{staticClass:"my-swipe",attrs:{"loop":false,"show-indicators":false},on:{"change":_vm.onChange}},_vm._l((_vm.dataList),function(item,index){return _c('van-swipe-item',{key:index},[_c('detail-page',{attrs:{"item":item,"index":_vm.nowIndex,"dataleng":_vm.dataList.length}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }